import * as React from 'react'
import { PaymentMethodInput } from '../payment-method-input';
import { PaymentMethod } from './payment-methods';

import { Styled } from './styled'

export const PaymentManager = (props) => {
  const {
    cards,
    primaryCardId,
    backupCardId,
    subscriptionCardId,
    setPrimaryCard,
    setBackupCard,
    setSubscriptionCard,
    removeCard,
    createCard,
  } = props;
  if (!cards || !cards.length) {
    return (
      <Styled.Container>
        <PaymentMethodInput onSubmit={createCard} />
      </Styled.Container>
    )
  }

  return (
    <Styled.Container>
      {cards.map((card, index) => (
        <PaymentMethod
          key={index}
          card={card}
          isPrimary={primaryCardId === card.id}
          isBackup={backupCardId === card.id}
          isSubscription={subscriptionCardId === card.id}
          setPrimaryCard={setPrimaryCard}
          setBackupCard={setBackupCard}
          setSubscriptionCard={setSubscriptionCard}
          removeCard={removeCard}
        />))
      }
      <PaymentMethodInput
        onSubmit={createCard}
        isCardInput={true}
      />
    </Styled.Container>
  );
}

